// serviceSaga.ts

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { API } from '../../api';
import {
  createServices,
  createServicesFailure,
  createServicesSuccess,
  getFilteredServices,
  getFilteredServicesFailure,
  getFilteredServicesSuccess,
  getServices,
  getServicesFailure,
  getServicesSuccess,
  removeServices,
  removeServicesFailure,
  removeServicesSuccess,
  updateServices,
  updateServicesFailure,
  updateServicesSuccess,
} from '../reducers/servicesSlice';

import { errorHandler } from './common';

function* getServicesSaga () {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, '/studios/services', {
      params: {
        limit: '500',
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(getServicesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getServicesSaga();
      },
      *callback () {
        yield put(getServicesFailure(error));
      },
    });
  }
}

function* getFilteredServicesSaga (action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, '/studios/services', {
      params: {
        limit: '500',
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(getFilteredServicesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getFilteredServicesSaga(action);
      },
      *callback () {
        yield put(getFilteredServicesFailure(error));
      },
    });
  }
}

interface createServicesSagaProp {
  payload: {
    studioId: string;
    title: string;
    image: string;
    duration: number;
    priceList: any;
    categories?: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* createServicesSaga ({
  payload: { studioId, title, image, duration, priceList, categories, onSuccess, onFailure },
}: createServicesSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/studios/${studioId}/services`,
      {
        title,
        image,
        duration,
        priceList,
        categories: categories || undefined,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    yield put(createServicesSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield createServicesSaga({
          payload: {
            studioId,
            title,
            image,
            duration,
            priceList,
            categories,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(createServicesFailure(error));
        onFailure(error);
      },
    });
  }
}

interface updateServicesSagaProp {
  payload: {
    studioId: string;
    serviceId: string;
    title?: string;
    image?: string;
    duration?: number;
    priceList?: any;
    categories?: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* updateServicesSaga ({
  payload: { studioId, serviceId, title, image, duration, priceList, categories, onSuccess, onFailure },
}: updateServicesSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.patch,
      `studios/${studioId}/services/${serviceId}`,
      {
        title,
        image,
        duration,
        priceList,
        categories,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    yield put(updateServicesSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield updateServicesSaga({
          payload: {
            studioId,
            serviceId,
            title,
            image,
            duration,
            priceList,
            categories,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(updateServicesFailure(error));
        onFailure(error);
      },
    });
  }
}

interface removeServicesSagaProp {
  payload: {
    studioId: any;
    serviceId: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* removeServicesSaga ({ payload: { studioId, serviceId, onSuccess, onFailure } }: removeServicesSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.delete, `/studios/${studioId}/services/${serviceId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(removeServicesSuccess(response.data));
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield removeServicesSaga({
          payload: { studioId, serviceId, onSuccess, onFailure },
        });
      },
      *callback () {
        yield put(removeServicesFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* servicesSaga () {
  // @ts-ignore
  yield takeLatest(getServices().type, getServicesSaga);
  // @ts-ignore
  yield takeLatest(getFilteredServices().type, getFilteredServicesSaga);
  // @ts-ignore
  yield takeLatest(createServices().type, createServicesSaga);
  // @ts-ignore
  yield takeLatest(updateServices().type, updateServicesSaga);
  // @ts-ignore
  yield takeLatest(removeServices().type, removeServicesSaga);
}
